module.exports = __webpack_public_path__ + "static/img/11022C_2_R_20190206_LC.5306a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/11022C_2_R_20190206_LC.png
// module id = DlyU
// module chunks = 0